import SpecialtyEventGiftView from './SpecialtyEventGiftView';

export default SpecialtyEventGiftView;
